import { useMemo } from 'react';
import dayjs from 'dayjs';

export const useWeeklyDateCalculations = (currentDate: dayjs.Dayjs) => {
  const thisWeekRange = useMemo(() => {
    const start = currentDate.utc().startOf('week');
    const end = currentDate.utc().endOf('week');
    return { start, end };
  }, [currentDate]);

  const dayNavigationState = useMemo(() => {
    const isNextDayDisabled = currentDate.isSame(dayjs(), 'day');
    const currentDay = dayjs().startOf('day');
    const daysDiff = currentDay.diff(currentDate.startOf('day'), 'day');
    const isPreviousDayDisabled = daysDiff >= 7;

    return { isNextDayDisabled, isPreviousDayDisabled };
  }, [currentDate]);

  const eventDateRanges = useMemo(() => {
    const weekRange = {
      start: dayjs(currentDate).startOf('week'),
      end: dayjs(currentDate).endOf('week'),
    };

    return { weekRange };
  }, [currentDate]);

  return {
    thisWeekRange,
    dayNavigationState,
    eventDateRanges,
  };
};
